module.exports = __webpack_public_path__ + "img/chaom-chau-branch.771e341a.jpg";